import script from "./WageBasicLoadEmp.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageBasicLoadEmp.vue?vue&type=script&setup=true&lang=ts"

import "./WageBasicLoadEmp.vue?vue&type=style&index=0&id=0df63a0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df63a0c"]])

export default __exports__